import withStyles from "@material-ui/core/styles/withStyles";
import {createStyles, Theme} from "@material-ui/core";
import * as React from "react";
import {DialogProps} from "@material-ui/core/Dialog";
import {TooltipProps} from "@material-ui/core/Tooltip";
import BasicEventChip, {BasicEventChipProps} from "./BasicEventChip";
import {QRLabelMapJSON} from "../../Quantification/QuantificationResultJSON";
import {ApiContext} from "hcla-web-frontend-primitives/app/components/primitives/Context/ApiContext";

export const cutsetItemStyles = (theme: Theme) => createStyles({
  chipRoot: {
    margin: `0px ${theme.spacing(0.5)}px`,
    flexDirection: 'row',
  },
});

export interface CutsetItemChipProps extends BasicEventChipProps {
  classes?: any;
}

const CutsetItemChip = (props: CutsetItemChipProps): React.ReactElement  => {
  const { classes: { chipRoot }, ...others } = props;
  return (
    <ApiContext.Consumer>
      {
        value => (
          // @ts-ignore
          <BasicEventChip
            classes={{
              root: chipRoot,
            }}
            apiManager={value.apiManager}
            {...others}
          />
        )
      }
    </ApiContext.Consumer>
  );
};

export default withStyles(cutsetItemStyles)(CutsetItemChip);

